import { ProgressIndicator } from "@fluentui/react";
import React from "react";

function IdicadorProgress({ isSend = false, subText='' }) {
    return (
        <div hidden={!isSend}>
            <ProgressIndicator description={`${subText} Espere Un Momento`} barHeight={3} />
        </div>
    );
}

export default IdicadorProgress;